import { FC } from 'react'
import { useDomain } from 'context'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { mobileBreakPoint } from 'app.styled/media'
import ArrowLeftIcon from 'svgIcons/ArrowLeft'
import NewWindowIcon from 'svgIcons/NewWindow'

const addSimpleParamToUrl = (url: string): string => {
  if (url.includes('?')) {
    return `${url}&simple=true`
  }

  const pathOnly = url.split('&')[0]
  return `${pathOnly}?simple=true`
}

interface MobileButtonsProps {
  backButtonLink: string
  isSimplePage: boolean
}

const NewWindowAndBackButton: FC<MobileButtonsProps> = ({
  backButtonLink,
  isSimplePage,
}) => {
  const router = useRouter()
  const { linkareer } = useDomain()

  const simplifiedUrl = `//${linkareer}${addSimpleParamToUrl(router.asPath)}`

  return (
    <HiddenSmDown>
      <StyledWrapper className={isSimplePage ? 'hidden' : ''}>
        <div className="icon-button-wrapper">
          <StyledIconButton
            as="a"
            id="open-cover-letter-in-new-tab-btn"
            className="icon-button"
            href={simplifiedUrl}
            target="_blank"
            rel="noopener"
          >
            <NewWindowIcon />
          </StyledIconButton>
          <p>새창</p>
        </div>
        <div className="icon-button-wrapper">
          <StyledIconButton
            as="a"
            id="back-to-cover-letter-list-btn"
            className="icon-button"
            href={backButtonLink}
          >
            <ArrowLeftIcon />
          </StyledIconButton>
          <p>목록</p>
        </div>
      </StyledWrapper>
    </HiddenSmDown>
  )
}

export default NewWindowAndBackButton

const StyledWrapper = styled.div`
  font-weight: 500;
  display: flex;
  justify-content: flex-end;
  min-width: 130px;

  &.hidden {
    display: none;
  }

  .icon-button-wrapper {
    display: flex;
    align-items: center;

    &:first-child {
      margin-right: 30px;
    }
  }

  .icon-button {
    color: #333;
    margin-right: 10px;
    background-color: #eee;

    &:hover {
      background-color: #ddd;
    }
  }
`

const HiddenSmDown = styled.div`
  ${mobileBreakPoint} {
    display: none;
  }
`

const StyledIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  background-color: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  border-radius: 0;
  padding: 12px;
  cursor: pointer;
  user-select: none;
  vertical-align: middle;
  text-decoration: none;
  color: inherit;
  border-radius: 50%;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  &:disabled {
    pointer-events: none;
    cursor: default;
  }
`
